// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:48
import { BootEventArgs_SL_abstract } from './../../abstract/SagaBase/Defines/BootEventArgs_SL_abstract';
export class BootEventArgs_SL extends BootEventArgs_SL_abstract {}
